
import { schema } from "./types";
import { OverviewPanel,OperatorPanel,ParameterPanel } from '.';
import { IconAHU } from "./IconAHU";
import { IAutomationAppComponent } from "../../../types";
import InsightsPanel from "../../components/PlantInsights/InsightsPanel";
import InsightsSideviewPanel from "../../components/PlantInsights/InsightsSideviewPanel";
import { ConfigurationPanel } from "./ConfigurationPanel";


export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: IconAHU,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsSideviewPanel,
    ConfigurationPanel: ConfigurationPanel,
    createConfig: {
        group: "Plants",
        name: "AHU 1 for Kitchen",
        description: "Air Handling Unit",
        panel: OverviewPanel,
        defaultState: {  showSupplyDuct: false, showEfficiency: false },
        defaultProperties: [
            { key: 'ShowSupplyDuct', value: 'true' },
            { key: 'ShowEfficiency', value: 'false' },
        ]
    },
}